import { useTranslation } from 'react-i18next';
import { useSettingsFormStore } from '../store';
import { SUPPORTED_LANGUAGES } from '../types';

const LANGUAGES = [
  { value: SUPPORTED_LANGUAGES.EN, label: 'English' },
  { value: SUPPORTED_LANGUAGES.RU, label: 'Русский' },
] as const;

export function LanguageSelector() {
  const { i18n } = useTranslation();
  const { t } = useTranslation();
  const language = useSettingsFormStore((s) => s.language);
  const setLanguage = useSettingsFormStore((s) => s.setLanguage);

  const handleChange = (value: string) => {
    setLanguage(value);
    void i18n.changeLanguage(value);
  };

  return (
    <div className="space-y-2">
      <h3
        className="text-sm font-medium text-tg-hint"
      >
        {t('settings.language')}
      </h3>
      <div className="flex gap-2">
        {LANGUAGES.map((lang) => (
          <button
            key={lang.value}
            type="button"
            onClick={() => handleChange(lang.value)}
            className="flex-1 rounded-lg px-4 py-2.5 text-sm font-medium transition-colors"
            style={{
              backgroundColor:
                language === lang.value
                  ? 'var(--tg-theme-button-color)'
                  : 'var(--tg-theme-secondary-bg-color)',
              color:
                language === lang.value
                  ? 'var(--tg-theme-button-text-color)'
                  : 'var(--tg-theme-text-color)',
            }}
          >
            {lang.label}
          </button>
        ))}
      </div>
    </div>
  );
}
